/*@ngInject*/
const DisableAutomationRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.disableAutomation = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/disableAutomation';
        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('disableAutomationRepository', DisableAutomationRepository);
